import React, { useContext, useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  Link,
  Icon,
  Divider,
  Box,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaWhatsapp } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { AppContext } from '../context/AppContext';

const MotionVStack = motion(VStack);
const MotionBox = motion(Box);

const WhatsappModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { userEmail } = useContext(AppContext);
  useEffect(() => {
    if (!userEmail) return;
    const lastShownDate = localStorage.getItem(`whatsapp_modal_last_shown_${userEmail}`);
    const today = new Date().toDateString();

    if (lastShownDate !== today) {
      setIsOpen(true);
    }
  }, [userEmail]);

  const handleClose = () => {
    if (!userEmail) return;
    const today = new Date().toDateString();
    localStorage.setItem(`whatsapp_modal_last_shown_${userEmail}`, today);
    setIsOpen(false);
    window.location.href = "https://whatsapp.com/channel/0029VaoiDVZFHWpurQ8h4o12";
  };

  const handleFollowClick = () => {
    // You can add logic here if you want to track the click before closing
  };

  const bgColor = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.800', 'white');

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
      },
    },
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="xl" isCentered>
      <ModalOverlay backdropFilter="blur(5px)" />
      <ModalContent bg={bgColor} color={textColor} borderRadius="xl">
        <ModalHeader textAlign="center">Connect With Us</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <MotionVStack
            spacing={3}
            align="stretch"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {/* English Section */}
            <MotionBox variants={itemVariants}>
              <Text fontWeight="bold" fontSize="md" mb={1}>
                Hello!
              </Text>
              <Text fontSize="sm">
                We have launched our official WhatsApp Channel, and we encourage all users to join. All important updates, announcements, service notifications, and valuable information related to our platform and website will be shared there first.<br/><br/>
                By joining, you’ll stay informed and receive updates as soon as they are released.
              </Text>
            </MotionBox>

            <MotionBox variants={itemVariants}>
              <Divider />
            </MotionBox>

            {/* Hindi Section */}
            <MotionBox variants={itemVariants}>
              <Text fontWeight="bold" fontSize="md" mb={1}>
                नमस्ते!
              </Text>
              <Text fontSize="sm">
                हमने अपना आधिकारिक व्हाट्सएप चैनल शुरू किया है। सभी उपयोगकर्ताओं से अनुरोध है कि वे इसे अवश्य जॉइन करें। हमारे प्लेटफ़ॉर्म और वेबसाइट से संबंधित सभी महत्वपूर्ण अपडेट, घोषणाएँ, सेवाओं की जानकारी और उपयोगी सूचनाएँ सबसे पहले इसी चैनल पर साझा की जाएँगी।<br/><br/>
                चैनल से जुड़कर आप सभी अपडेट समय पर प्राप्त कर सकेंगे और किसी भी महत्वपूर्ण जानकारी से वंचित नहीं रहेंगे।
              </Text>
            </MotionBox>

            {/* Combined Call to Action */}
            <MotionBox textAlign="center" pt={1} variants={itemVariants}>
              <Text fontSize="sm" fontWeight="semibold">
                👉 Join our WhatsApp Channel: <Link href="https://whatsapp.com/channel/0029VaoiDVZFHWpurQ8h4o12" isExternal color="green.500" onClick={handleFollowClick}>Click here!</Link>
              </Text>
              <Text fontSize="sm" fontWeight="semibold" mt={1}>
                👉 हमारे व्हाट्सएप चैनल से जुड़ें: <Link href="https://whatsapp.com/channel/0029VaoiDVZFHWpurQ8h4o12" isExternal color="green.500" onClick={handleFollowClick}>Click here!</Link>
              </Text>
              <Link href="https://whatsapp.com/channel/0029VaoiDVZFHWpurQ8h4o12" isExternal onClick={handleFollowClick} display="inline-block" mt={2}>
                <MotionBox
                  display="inline-block"
                  whileHover={{ scale: 1.2, rotate: 10 }}
                  animate={{
                    scale: [1, 1.1, 1],
                    rotate: [0, 5, -5, 0],
                  }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut"
                  }}
                >
                  <Icon as={FaWhatsapp} w={10} h={10} color="green.500" />
                </MotionBox>
              </Link>
            </MotionBox>
          </MotionVStack>
        </ModalBody>

        <ModalFooter justifyContent="center">
          <Button colorScheme="green" onClick={handleClose} size="lg" w="full">
            OK, I Joined
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default WhatsappModal;
